import { useQuery, gql } from "@apollo/client"

const ORGANISATION_TEMPLATE_COUNTS_QUERY = gql`
  query OrganisationTemplateCounts {
    organisationTemplateCounts {
      activeRecurring
      activeOneoff
      activeAdhoc
      activeTasks
      inactiveRecurring
      inactiveOneoff
      inactiveAdhoc
      inactiveTasks
    }
  }
`

const useQueryOrganisationTemplateCounts = (options) =>
  useQuery(ORGANISATION_TEMPLATE_COUNTS_QUERY, {
    fetchPolicy: "cache-and-network",
    ...options,
  })

export { useQueryOrganisationTemplateCounts }
